import { Injectable } from '@angular/core';
import { ILatLngBounds, IGoogleMap, ILatLng } from 'src/app/core/models/google-map-models';
import { AAGoogleIconService } from '../aa-google-icon/aagoogle-icon.service';
import { GoogleMapGeoService } from '../aa-google-geo/google-map-geo.service';
import { ITrafficAlertsTopHits } from 'src/app/core/models/models';
import { GoogleInfoWindowService } from 'src/app/modules/google-map/services/google-info-window/google-info-window.service';
import { AAClusterType } from 'src/app/modules/google-map/enums/google-map-enum';

export interface IAAGOogleMarkerService {
  createClusterMarker(googleMap: IGoogleMap, trafficCarModel, count: number, clusterType: AAClusterType): any;
  createTrafficAlertMarker(markerDataObj: ITrafficAlertsTopHits, googleMap: IGoogleMap): any;
}

@Injectable({
  providedIn: 'root'
})
export class AAGoogleMarkerService implements IAAGOogleMarkerService {

  constructor(
    private googleIconManager: AAGoogleIconService,
    private googleInfoWindow: GoogleInfoWindowService,
    private googleMapGeo: GoogleMapGeoService) { }


  public createMarker(googleMap, latLng: ILatLng, label): any {
    const marker = new google.maps.Marker({
      position: latLng,
      map: googleMap,
      // icon: this.googleIconManager.getTrafficAlertIcon(markerDataObj.aaIncidentType),
      title: label,
    });

    return marker;
  }

  public createTrafficAlertMarker(markerDataObj: ITrafficAlertsTopHits, googleMap: IGoogleMap, isVisible?: boolean, html?: string): any {
    const IconShadow = this.googleIconManager.iconShadow();

    const taShape = { coord: [1, 1, 1, 30, 28, 30, 28, 1], type: 'poly' };

    const taMarker = new google.maps.Marker({
      position: new google.maps.LatLng(markerDataObj.lat, markerDataObj.lon),
      map: googleMap,
      icon: this.googleIconManager.getTrafficAlertIcon(markerDataObj.aaIncidentType),
      title: markerDataObj.eventText,
      shape: taShape,
      shadow: IconShadow,
      html: html
    });
    taMarker.category = 'trafficalerts';
    taMarker.data = markerDataObj;
    taMarker.setVisible(isVisible);

    google.maps.event.addListener(taMarker, 'click', () => {
      this.googleInfoWindow.close();
      this.googleInfoWindow.setContent(html);
      this.googleInfoWindow.open(googleMap, taMarker);
    });

    return taMarker;
  }


  public createClusterMarker(googleMap: IGoogleMap, trafficCarModel, count: number, clusterType: AAClusterType): any {
    const iconShadow = this.googleIconManager.iconShadow();

    const clusterIcon = this.googleIconManager.getClusterIcon(clusterType);
    const taShape = { coord: [8, 0, 17, 15, 0, 15], type: 'poly' };

    const labelObj = {
        text: String(count),
        fontSize: '12px',
        color: '#fff'
        // fontWeight: "bold"
      };

    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(trafficCarModel.lat, trafficCarModel.lon),
      label: labelObj,
      map: googleMap,
      icon: clusterIcon,
      geoHash: trafficCarModel.geoHash,
      // shape: taShape,
      // shadow: iconShadow,
      category : 'trafficalerts',
    });

    google.maps.event.addListener(marker, 'click', (event) => {
      if (marker.geoHash) {
        const bounds: ILatLngBounds = this.googleMapGeo.latLngBounds(marker.geoHash);

        // fitBounds or zoom
        const prevZoom = googleMap.getZoom();
        googleMap.fitBounds(bounds);

        if (prevZoom === googleMap.getZoom() ) {
          googleMap.setZoom( googleMap.getZoom() + 1);
        }
        googleMap.setCenter(bounds.getCenter());

        // draw rectangle
        // if(this.tempRectangle) this.tempRectangle.setMap(null);
        // this.tempRectangle = this.googleIconManager.drawRectangle(bounds);
        // this.tempRectangle.setMap(googleMap);
      }
    });

    return marker;
  }

  // private tempRectangle:any;
}
